import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import classnames from 'classnames'
import { addMenu } from '../../../actions/design/blogmenu'
import AddButton from "./AddButton"
import { TYPES, defaultType } from './MenuType'
import TypeDetailForm from "./TypeDetailForm"
import { isUrl } from '../../../utils/formatter'
import TInputForm from "../../common/TInputForm";
import MenuSelectForm from "./MenuSelectForm";

function Form({onClose}) {
  const types = useSelector(state => state.blogmenu.types)
  const dispatch = useDispatch()

  const [typeFormFocused, setTypeFormFocused] = useState(false)
  const [typeDetailFormFocused, setTypeDetailFormFocused] = useState(false)
  const [selectedType, setSelectedType] = useState(defaultType())
  const [name, setName] = useState('')
  const [type, setType] = useState(types.find(type => type.id === 13))
  const [url, setUrl] = useState('')
  const [isNewWindow, setIsNewWindow] = useState(false)
  const [validated, setValidated] = useState(false)

  function handleChangeTypeAndUrl(typeId, url) {
    const type = types.find(type => type.id === typeId)
    setType(type)
    setUrl(url)

    if (type && type.isDefault) {
      setName(type.name)
    }
  }

  function handleSubmit(e) {
    e.preventDefault()

    dispatch(addMenu({
      name: name,
      typeId: type.id,
      url: url,
      isNewWindow: type.id === 13 && isNewWindow
    }))

    onClose()
  }

  function checkValidate() {
    if (name.length === 0 || !type) {
      return false
    }

    if (type.id >= 9 && url.length === 0) {
      return false
    }

    if (type.id === 13 && !isUrl(url)) {
      return false
    }

    return true
  }

  useEffect(() => {
    setValidated(checkValidate())
  }, [name, type, url])

  return (
    <div className="wrap_add item_edit">
      <form className="item_order" onSubmit={handleSubmit} onReset={onClose}>
        <div className="edit_item">
          <label className="lab_tf">
            <strong className="screen_out">메뉴명</strong>
            <TInputForm
              type="text" className="tf_blog"
              placeholder="이름" tabIndex="1"
              value={name} onChange={name => setName(name)}
            />
          </label>
          <div className={classnames("menu_opt", { "menu_on": typeFormFocused || typeDetailFormFocused })}>
            <MenuSelectForm
              className="opt_menu" items={TYPES} selected={selectedType.value}
              onSelect={type => setSelectedType(type)}
              onFocus={setTypeFormFocused}
              onBlur={setTypeFormFocused}
            />
            <TypeDetailForm
              selectedType={selectedType}
              onChange={(typeId, url) => handleChangeTypeAndUrl(typeId, url)}
              onChangeFocus={setTypeDetailFormFocused}
            />
          </div>
          {selectedType.value === 'url' &&
            <div className="check_blog">
              <input
                type="checkbox" id="linkBlank" className="inp_check" tabIndex="4"
                checked={isNewWindow} onChange={() => setIsNewWindow(!isNewWindow)}
              />
              <label htmlFor="linkBlank" className="lab_check">
                <span className="ico_blog ico_checkbox" />새창으로 열기
              </label>
            </div>
          }
          <div className="order_btn">
            <button type="reset" className="btn_cancel" tabIndex="5">취소</button>
            <button type="submit" className={classnames("btn_default", { "btn_off": !validated })} disabled={!validated} tabIndex="6">추가</button>
          </div>
        </div>
      </form>
    </div>
  )
}



export default function ItemForm() {
  const [open, setOpen] = useState(false)
  if (!open) {
    return <AddButton onClick={() => setOpen(true)} />
  } else {
    return <Form onClose={() => setOpen(false)} />
  }
}
